// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"670":"refractor-vendor","920":"parse5-vendor","940":"codemirror-vendor"}[chunkId] || chunkId) + "." + {"102":"5386f7dc","543":"b76cd1bb","647":"6dd4d8f2","670":"313ac818","920":"cb0b7277","940":"e60b178a"}[chunkId] + ".chunk.js";
};